import request from '@/utils/logRequest'
export default {
  login(name, password, { captcha, captchaId, userType, isPlatformOperate }) {
    let url = isPlatformOperate ? '/web/admin/login' : '/web/user/login'
    let formData = new FormData()
    formData.append('code', name);
    formData.append('pwd', password);
    formData.append('captcha', captcha);
    formData.append('captchaId', captchaId);
    formData.append('userType', userType);
    return request({ url: url, method: "post", data: formData });
  },
  refresh(tokenJson) {
    return request({ url: "/auth/token/refresh", method: "post", params: tokenJson });
  },
  changeSchool(id){
    return request({ url: `/web/common/sysman/user/changeFirm?firmId=${id}`, method: "put" });
  },
  changesToSchool(id){
    return request({ url: `/web/admin/sysman/adminuserlogin/enterSchool?firmId=${id}`, method: "get" });
  },
  changesToYunying(id){
    return request({ url: `/web/admin/sysman/adminuserlogin/returnToOperations?firmId=${id}`, method: "get" });
  },
  changeFirm(id, token) {
    return request({ url: "/auth/firm/change?firmId=" + id + "&token=" + token, method: "post" });
  },
  register(registerdata) {
    return request({ method: "post", url: "/user/register", params: registerdata });
  },
  retrievePwd(data) {
    return request({ method: "post", url: "/user/forgot/password?telephone=" + data.phone + "&newPassword=" + data.password + "&verifyPassword=" + data.confirmPassword + "&tokenKey=" + data.token });
  },
  sendVerification(phone) {
    return request({ method: "post", url: "/user/send/verification?telephone=" + phone });
  },
  checkVerification(verdata) {
    return request({ method: "post", url: "/user/check/verification/code?telephone=" + verdata.phone + "&code=" + verdata.code });
  },
  getOnlineTotal() {
    return request({ url: "/online/monitoring/count", method: "get" });
  }
}
